import React from 'react';

import { Logo } from '@ergeon/core-components';

import FooterMenu from './FooterMenu';
import FooterTerms from './FooterTerms';
import SocialLinks from './SocialLinks';
import { useFooterMenu } from './useFooterMenu';
import { FooterProps } from './types';

const Footer: React.FC<FooterProps> = ({ ergeonUrl, projectsGalleryUrl }) => {
  const menuColumns = useFooterMenu(ergeonUrl, projectsGalleryUrl);

  return (
    <footer className="bg-gray-50 mt-12 py-12">
      <div className="mx-auto px-4 max-w-7xl">
        <div className="flex md:flex-row flex-col md:justify-between gap-8 mb-8">
          <div className="flex flex-col gap-4">
            <Logo href={ergeonUrl} size="large" />
            <SocialLinks />
          </div>
          <FooterMenu columns={menuColumns} />
        </div>
        <FooterTerms ergeonUrl={ergeonUrl} />
      </div>
    </footer>
  );
};

export default Footer;
